import { createContext } from "react";
import { Organization } from "../dto/Organization";

export interface OrganizationContextInterface 
{
    organization: Organization;
    organizationId: string;
}

export default createContext<OrganizationContextInterface>({ organization: null, organizationId: null });